export function publicAppUrl(): string {
  return process.env.NEXT_PUBLIC_PUBLIC_APP_URL || "";
}
